import React from "react";
import {useIntl} from "react-intl";
import {Card, CardHeader, CardContent, Grid} from "@material-ui/core";
import {Language} from "@material-ui/icons";
import GraphQLEditForm from "components/GraphQL/GraphQLEditForm";

export default function LanguageEdit(props) {
    const intl = useIntl();

    let id = Number(props.match.params.id);

    const fields = [
        {
            field: "name",
            initial: "",
            type: "String",
            label: intl.formatMessage({id: "languages.edit.label.name", defaultMessage: "Name"}),
            input: "text"
        },
        {
            field: "country_code",
            initial: "",
            type: "String",
            label: intl.formatMessage({
                id: "languages.edit.label.country_code",
                defaultMessage: "Country code (DK, UK, US, DE, etc.)"
            }),
            input: "text"
        },
        {
            field: "locale",
            initial: "",
            type: "String",
            label: intl.formatMessage({
                id: "languages.edit.label.locale",
                defaultMessage: "Locale (da, de, en, es, se, etc.)"
            }),
            input: "text"
        }
    ];

    return (
        <Grid container>
            <Grid item xs={12}>
                <Card>
                    <CardHeader
                        color="primary"
                        avatar={<Language/>}
                        title={intl.formatMessage({id: "languages.edit.heading"})}/>
                    <CardContent>
                        <GraphQLEditForm
                            id={id}
                            query={"languages"}
                            mutations={"language"}
                            fields={fields}
                            cols={2}
                            {...props}
                        />
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}